import { createTypes } from 'redux-recompose';

// ACTIONS RELATIVE AL TOAST
export const actions = createTypes(['SHOW_NOTIFICATION', 'REMOVE_NOTIFICATION'], '@@PML');

const actionCreators = {
  SHOW_NOTIFICATION: (response) => ({ type: actions.SHOW_NOTIFICATION, notification: response }),
  REMOVE_NOTIFICATION: () => ({ type: actions.REMOVE_NOTIFICATION }),
};

export default actionCreators;